import { render, staticRenderFns } from "./SurveyV3.vue?vue&type=template&id=7fb5a71e&scoped=true"
import script from "./SurveyV3.vue?vue&type=script&lang=js"
export * from "./SurveyV3.vue?vue&type=script&lang=js"
import style0 from "./SurveyV3.vue?vue&type=style&index=0&id=7fb5a71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5a71e",
  null
  
)

export default component.exports